//------------------------------------------------------------------
// Description: The DSC Connection object encapsulates DSC communication protocol. DSC messaging protocol is based on
//              HTTP. There are 2 types of messages: requests and event updates. HTTP POST is used to send requests and
//				HTTP Long Polling is used for unsolicited event updates.
//              HTTP POST is used rather than GET for all requests since all requests contain Data XML node, the size of 
//              which is really dictated by the application protocol and this could hit the GET size limits. By using POST
//              The application protocol can be kept independent of the communication protocol.
//              Conferencing also requires clients get event updates as they happen. Since HTTP is a request-response
//              protocol, an outstanding request is required to get any updates from server. To do this right, a mechanism
//              called long polling is used. Long polling (http://en.wikipedia.org/wiki/Push_technology#Long_polling) is a 
//              mechanism where a request is made and the server responds when there is useable data available (or after an
//              appropriate timeout.) In our case the DSC message used for that standing request is "Register For Events".
//              This is the only message that this component sends and handles. The client of this component should never
//              send this message. The server on receipt of this message returns in response any event updates as a list of
//              forwarded messages or an empty message list. By grouping messages, the number of request responses are optimized
//              The timeout used here is 5 seconds (a property of the server.) This offers a good balance between lags or
//              extreme traffic introduced by regular polling.
//              The event update request uses a separate connection from the request/response connection. This avoids potential
//              lag in making client requests.
//              Use of AJAX also helps in not blocking client module.
//              
// Author:      Kiran Saligrama
// Module Design:
//              setDSCURI: a method to set the relative URI for DSC Server. This is used with the window.location.host to
//                         build the complete URI. By default this is "dscserver"
//              addDSCMessageHandler: Whenever a response or event update is received by this component, a client specified message
//                                    handler is called. There can be more than one message handler per message type. All handlers for
//                                    the given message type are called when a response/update is received.
//              addDSCErrorHandler: Error handlers are called when there are errors at the message level or at the communication level.
//              sendDSCMessage: This method sends the client message if there are no outstanding requests. If there is an outstanding
//                              request, the message is queued.
//                              The "latest only" logic is implemented by replacing the previous message of that type. The latestMsgOnly
//                              array contains the mapping from messge type to latest only state.
// 
// Date ------  Developer -- Description ----------------------------
// 22 Sept 2011 SK           Original
// 14 Oct  2011 SK           Add error handlers, message queue to make the client interface more robust. Declare interface using closure. 
//                           Does not need over-riding of window.onload any more.
// 23 Oct  2011 SK           Add latest only feature
// 18 Nov  2011 SK           Create new XHR object rather than reuse.
// 23 Jan  2012 SK           User dscConsoleLog rather than console.log. Prevents exceptions when debug console is not turned on
// 11 Jun  2012 SK           Add network error type to report network errors
// 03 Jun  2014 CB           Modifications to support IE11 where window.ActiveXObject property is now hidden. 
//							 Used recommended try/catch workaround: http://msdn.microsoft.com/en-us/library/ie/dn423948(v=vs.85).aspx	
//------------------------------------------------------------------

var g_dscConnection = (function () {
	var ___DEBUG___ = false;
	var ___DEBUG2___ = false;

	var that = null;

	var xhr = null;
	var xhrEvent = null;

	var dscURL = "";

	var dscMessageHandlers = [[], []];
	var dscErrorHandlers = [];

	var latestMsgOnly = [];
	latestMsgOnly[_dscMessageTypes.confManagementMessage] = false;
	latestMsgOnly[_dscMessageTypes.confAttributeMessage] = false;
	latestMsgOnly[_dscMessageTypes.confImagePositionUpdateMessage] = true;
	latestMsgOnly[_dscMessageTypes.confMarkerPositionUpdateMessage] = true;
	latestMsgOnly[_dscMessageTypes.confEventUpdateRegistration] = false;

	var lastMsgSent = null;

	var clientId = -1;

	return {
		setDSCURI: function (value) { dscURL = window.location.protocol + "//" + window.location.host + "/" + value + "/"; },

		addDSCMessageHandler: function (msgType, handlerFunction) {
			if (msgType in dscMessageHandlers)
				dscMessageHandlers[msgType].push(handlerFunction);
		},

		addDSCErrorHandler: function (handlerFunction) {
			dscErrorHandlers.push(handlerFunction);
		},

		reset: function () {
			clientId = -1;
			if (xhr != null)
				xhr.abort();
			xhr = null;
			if (xhrEvent != null)
				xhrEvent.abort();
			xhrEvent = null;
			dscMessageQueue.resetQueue();
			dscMessageHandlers = [[], []];
			dscErrorHandlers = [];
		},

		init: function () {
			that = this;
			xhr = createXHRObj();
			xhrEvent = createXHRObj();
			this.setDSCURI("dscserver");
		},
		sendDSCMessage: function (msgTitle, msgDataNode, msgType, xhrObject, respHandler) {
			if (xhr == null)
				this.init();
			var msgObj = new msgMaker(msgTitle, msgDataNode, msgType);
			if (isXHRBusy(xhr)) {
				dscMessageQueue.addMessage(msgObj, (latestMsgOnly[msgType] !== undefined) ? latestMsgOnly[msgType] : false);
				return;
			}
			sendDSCMessageInt(msgObj, undefined, undefined);
		}
	};

	function isXHRBusy(inXHR) {
		if ((inXHR !== null) && (inXHR.readyState !== 0) && (inXHR.readyState !== 4)) {
			return true;
		}
		return false;
	}

	/*
	*DSC message response handlers
	*/

	function dscMessageSink() {
		//output response XML to debug div
		if (xhr.readyState == 4) {
			if (xhr.status == 200) {
				if (xhr.responseXML != undefined)
					handleDSCResponse(xhr.responseXML);
			}
			else {
				for (var errHdlrInd = 0; errHdlrInd < dscErrorHandlers.length; errHdlrInd++) {
					dscErrorHandlers[errHdlrInd](_dscErrorTypes.confNetError, null, null);
				}
				if (___DEBUG___ && (document.getElementById("lastDSCReqResp") !== null))
					document.getElementById("lastDSCReqResp").innerHTML = "HTTP error from last DSC call" + xhr.status;
			}
		}
	}

	function handleDSCResponse(dscRespXML) {
		var dscRoot = dscRespXML.documentElement;
		//debug start
		var respClientId = parseInt(dscRoot.getElementsByTagName("To")[0].attributes.getNamedItem("Id").value, 10);
		if ((clientId != -1) && (respClientId != -1) && (respClientId !== clientId))
			dscConsoleLog("#### Incorrect clientId. Recieved Id = " + respClientId + " Saved client id = " + clientId);
		//debug end
		var respType = dscRoot.attributes.getNamedItem("Type").value;
		var statusNd = dscRoot.getElementsByTagName("Data")[0].getElementsByTagName("Status")[0].getElementsByTagName("Value")[0];
		if ((statusNd.textContent || statusNd.text) !== "0") {
			if (dscErrorHandlers != null)
				for (var errHdlrInd = 0; errHdlrInd < dscErrorHandlers.length; errHdlrInd++) {
					dscErrorHandlers[errHdlrInd](_dscErrorTypes.confMsgError, respType, dscRoot);
				}
			return;
		}
		else if (___DEBUG2___)
			dscConsoleLog(respType + " recieved");

		dscMessageRouter(respType, dscRoot);
		if (!isXHRBusy(xhr)) {
			var msgObj = dscMessageQueue.getNextMessage();
			if (msgObj != null)
				sendDSCMessageInt(msgObj, undefined, undefined);
		}
	}

	function dscMessageRouter(respType, dscRoot) {
		if (respType == "New Participant Response") {
			clientId = parseInt(dscRoot.getElementsByTagName("To")[0].attributes.getNamedItem("Id").value, 10);
			registerForEvent();
		}
		var dscMsgType;
		if ((respType == "Insert Conference Attribute") ||
		(respType == "Update Conference Attribute") ||
		(respType == "Delete Conference Attribute")) {
			dscMsgType = _dscMessageTypes.confAttributeMessage;
		}
		else {
			dscMsgType = _dscMessageTypes.confManagementMessage;
		}
		for (var msgHdlrInd = 0; msgHdlrInd < dscMessageHandlers[dscMsgType].length; msgHdlrInd++) {
			dscMessageHandlers[dscMsgType][msgHdlrInd](respType, dscRoot);
		}
	}

	/************
	DSC Event registration and handler functions
	************/
	function registerForEvent() {
		//send a register message	"Register For Events"
		//Create empty data node
		var msgDoc = createDSCMsgDocument("Register For Events");

		var dataNd = msgDoc.createElement("Data"); 									    //create Data node
		var msgObj = new msgMaker("Register For Events", dataNd, _dscMessageTypes.confEventUpdateRegistration);
		//that.sendDSCMessage("Register For Events", dataNd, xhrEvent, dscEventSink);
		xhrEvent = createXHRObj();
		sendDSCMessageInt(msgObj, xhrEvent, dscEventSink);
	}

	function dscEventSink() {
		//output response XML to debug div
		if (xhrEvent.readyState == 4) {
			var logDiv = document.getElementById("lastDSCEvent");
			if (xhrEvent.status && xhrEvent.status == 200) {
				if (xhrEvent.responseXML !== undefined) {
					var msg, msgList, msgInd;
					msgList = xhrEvent.responseXML.documentElement.getElementsByTagName("MVM_Message");
					for (msgInd = 0; msgInd < msgList.length; msgInd++) {
						msg = msgList[msgInd];
						if (logDiv && ___DEBUG___)
							logDiv.innerHTML += msg.attributes.getNamedItem("Type").value + "\n";
						var respType = msg.attributes.getNamedItem("Type").value;
						dscMessageRouter(respType, msg);
						if (___DEBUG2___)
							dscConsoleLog("Recieved message" + respType);
					}
				}
				registerForEvent();
			}
			else {
				for (var errHdlrInd = 0; errHdlrInd < dscErrorHandlers.length; errHdlrInd++) {
					dscErrorHandlers[errHdlrInd](_dscErrorTypes.confNetError, null, null);
				}
				if (logDiv)
					logDiv.innerHTML = "HTTP error from last DSC call - status:" + xhrEvent.status;
			}
		}
	}

	/************
	Generic DSC message utility functions
	************/

	function sendDSCMessageInt(msgObj, xhrObject, respHandler) {
		if (xhr == null)
			that.init();
		//Create MVM message document
		var msgDoc = createDSCMsgDocument();
		msgDoc.documentElement.setAttribute("Type", msgObj.getTitle()); 	//set message type

		nd = msgDoc.createElement("From"); 									//Add From node
		nd.setAttribute("Id", String(clientId));
		msgDoc.documentElement.appendChild(nd);

		nd = msgDoc.createElement("To"); 									//add To node
		nd.setAttribute("Id", "0");
		msgDoc.documentElement.appendChild(nd);

		msgDoc.documentElement.appendChild(msgObj.getDataNode()); 			//add Data node

		var xhrToUse = (xhrObject === undefined) ? xhr = createXHRObj() : xhrObject;
		if (xhrToUse) {
			if (xhrToUse.readyState != 0)
				xhrToUse.abort();
			xhrToUse.open("POST", dscURL + clientId + Math.floor(Math.random() * 10000), true);

			xhrToUse.setRequestHeader("Content-type", "text/xml; charset=utf-8");
			xhrToUse.responseType = 'document';
			
			if (respHandler === undefined)
				xhrToUse.onreadystatechange = dscMessageSink;
			else
				xhrToUse.onreadystatechange = respHandler;
			xhrToUse.send(msgDoc);
			lastMsgSent = msgObj;
			if (___DEBUG2___)
				dscConsoleLog("Sent message" + msgObj.getTitle());
		}
	}

	function createDSCMsgDocument(msgType) {
		var xmlDoc = null;
		try {
			xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
			xmlDoc.async = false;
			dscMsgElem = xmlDoc.createElement("MVM_Message")
			xmlDoc.documentElement = dscMsgElem;
		}
		catch (e) {
			xmlDoc = document.implementation.createDocument("", "MVM_Message", null);
		}
		xmlDoc.documentElement.setAttribute("Type", msgType); 				//set message type

		return xmlDoc;
	}

	function createXHRObj() {
		var xhr = null;
		if (window.XMLHttpRequest) {
			xhr = new XMLHttpRequest();
		}
		else {		
				try {
					xhr = new ActiveXObject("Microsoft.XMLHTTP");
				}
				catch (e) {
					return null;
				}
		}
		return xhr;
	}
})();

function dscConsoleLog(msg) {
    if (window.console )
        console.log(msg);
}

